(function () {
  var MEASUREMENT_NOTE = 'All measurements are garment measurements, not body measurements.';

  function findKiwiButton() {
    return document.querySelector('.ks-chart-modal-link, .sizing-chart-modal-link');
  }

  function moveKiwiSizeChart() {
    var slot = document.querySelector('[data-tc-size-chart-slot]');
    if (!slot) return false;

    var link = findKiwiButton();
    if (!link) return false;
    if (slot.contains(link)) return true;

    var node = link.closest('.ks-container-with-modal') || link.closest('.ks-chart-container') || link;
    slot.appendChild(node);
    return true;
  }

  function injectKiwiMeasurementNote() {
    var headers = document.querySelectorAll('.modal-title-header');
    headers.forEach(function (header) {
      if (!header || header.dataset.tcNoteBound === 'true') return;
      var next = header.nextElementSibling;
      if (next && next.classList.contains('tc-size-chart-note')) {
        header.dataset.tcNoteBound = 'true';
        return;
      }
      var note = document.createElement('p');
      note.className = 'tc-size-chart-note';
      note.textContent = MEASUREMENT_NOTE;
      header.insertAdjacentElement('afterend', note);
      header.dataset.tcNoteBound = 'true';
    });
  }

  function start() {
    if (moveKiwiSizeChart()) return;

    var observer = new MutationObserver(function () {
      if (moveKiwiSizeChart()) observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
      moveKiwiSizeChart();
    }, 8000);
  }

  function watchKiwiModal() {
    injectKiwiMeasurementNote();
    var observer = new MutationObserver(function () {
      injectKiwiMeasurementNote();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function formatMeasure(inches, unit) {
    var n = parseFloat(inches);
    if (isNaN(n)) return inches;
    if (unit === 'cm') n = Math.round(n * 2.54 * 10) / 10;
    if (Math.abs(n - Math.round(n)) < 0.001) return String(Math.round(n));
    return String(n);
  }

  function setUnit(table, unit) {
    table.querySelectorAll('[data-inches]').forEach(function (cell) {
      cell.textContent = formatMeasure(cell.getAttribute('data-inches'), unit);
    });
    table.querySelectorAll('[data-unit]').forEach(function (button) {
      button.classList.toggle('is-active', button.getAttribute('data-unit') === unit);
    });
  }

  function bindSizeChart() {
    var dialog = document.querySelector('[data-tc-size-chart]');
    var open = document.querySelector('[data-tc-size-chart-open]');
    if (!dialog || !open || dialog.dataset.tcBound === 'true') return;

    dialog.dataset.tcBound = 'true';

    open.addEventListener('click', function () {
      dialog.querySelectorAll('[data-tc-size-table]').forEach(function (table) {
        setUnit(table, 'in');
      });
      dialog.showModal();
    });

    dialog.querySelector('[data-tc-size-chart-close]').addEventListener('click', function () {
      dialog.close();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('click', function (event) {
      var button = event.target.closest('[data-unit]');
      if (!button || !dialog.contains(button)) return;
      var table = button.closest('[data-tc-size-table]');
      if (table) setUnit(table, button.getAttribute('data-unit'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start();
      bindSizeChart();
      watchKiwiModal();
    });
  } else {
    start();
    bindSizeChart();
    watchKiwiModal();
  }
})();
